import { ReactNode } from "react";
import { useAttributePermission } from "./usePermission";

interface AttributePermissionGateProps {
  application: string;
  feature: string;
  attribute: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function AttributePermissionGate({
  application,
  feature,
  attribute,
  children,
  fallback = null,
}: AttributePermissionGateProps) {
  const allowed = useAttributePermission(application, feature, attribute);
  return <>{allowed ? children : fallback}</>;
}
